import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LanguageProvider } from "@/i18n";
import Navbar from "@/components/Navbar";
import Home from "@/pages/Home";
import SectorPage from "@/pages/SectorPage";
import FinancePage from "@/pages/sectors/FinancePage";
import RetailPage from "@/pages/sectors/RetailPage";
import EnergyPage from "@/pages/sectors/EnergyPage";
import TourismPage from "@/pages/sectors/TourismPage";
import CommercialPage from "@/pages/sectors/CommercialPage";
import ResidentialPage from "@/pages/sectors/ResidentialPage";

// Routes that use the light (white) theme — no grain/vignette, white shell.
const LIGHT_ROUTES = ["/sectors/tourism", "/sectors/finance", "/sectors/energy"];
// The Taurus / Commercial page — its own anthracite shell, white text, no grain/vignette.
const ANTHRACITE_ROUTES = ["/sectors/commercial"];
// The Retail / Liquor Store page — a dark "tobacco" brown shell, white text.
const TOBACCO_ROUTES = ["/sectors/retail"];
// The Meliora / Residential page — a warm brown shell (the Sectors tile colour), white text.
const MELIORA_ROUTES = ["/sectors/residential"];

function Shell() {
  const { pathname } = useLocation();
  const light = LIGHT_ROUTES.includes(pathname);
  const anthracite = ANTHRACITE_ROUTES.includes(pathname);
  const tobacco = TOBACCO_ROUTES.includes(pathname);
  const meliora = MELIORA_ROUTES.includes(pathname);

  return (
    <div
      className={`App font-sans ${
        light
          ? "bg-white text-ink"
          : anthracite
          ? "bg-[#16181a] text-white"
          : tobacco
          ? "bg-tobacco text-white"
          : meliora
          ? "bg-[#47352e] text-white"
          : "grain vignette bg-ink text-white"
      }`}
    >
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/sectors/finance" element={<FinancePage />} />
        <Route path="/sectors/retail" element={<RetailPage />} />
        <Route path="/sectors/energy" element={<EnergyPage />} />
        <Route path="/sectors/tourism" element={<TourismPage />} />
        <Route path="/sectors/commercial" element={<CommercialPage />} />
        <Route path="/sectors/residential" element={<ResidentialPage />} />
        <Route path="/sectors/:slug" element={<SectorPage />} />
        <Route path="*" element={<Home />} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
